import { module } from 'angular';

// TODO not use for now

export default module('contact.commons.toolbox.smart-table', []).name;
